module.exports = __webpack_public_path__ + "static/media/settings-icon.efccdcc0.svg";